import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OperacionesComponent} from "../../operaciones.component";
import {OperationService} from "../../../../../../core/services/parameters/operation.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-parameter.component.html',
  styleUrls: ['./confirm-delete-parameter.component.scss']
})
export class ConfirmDeleteParameterComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<OperacionesComponent>,
    private operationService: OperationService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.operationService.deleteOperation(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
